import { wasmModule } from "../wasm/wasmModule"

class GlobalMovement {
  // 控制开关，本模块调用需要先开启开关
  ToggleLowerArchMove(isOpen: boolean) {
    if (!wasmModule.isFinishedOpencase) {
      return
    }
    try {
      wasmModule.moduleManager.ToggleLowerArchMove(isOpen)
    } catch (e) {
      console.log("ToggleLowerArchMove 开启失败:", e)
    }
  }

  // 获取当前模块的内容实例方法
  GetModuleLowerArchMovement() {
    if (!wasmModule.isFinishedOpencase) {
      return undefined
    }
    try {
      return wasmModule.moduleManager.GetModuleLowerArchMovement()
    } catch (e) {
      console.log("获取 ToggleLowerArchMove 方法:", e)
      return null
    }
  }

  // 获取 GM 移动距离
  GetMoveDistance() {
    try {
      const lowerArchMovementModule = this.GetModuleLowerArchMovement()
      if (!lowerArchMovementModule) {
        return
      }
      return lowerArchMovementModule.GetMoveDistance()
    } catch (e) {
      console.log("GetMoveDistance:", e)
      return null
    }
  }

  // 获取 GM 旋转角度
  GetRotateAngle() {
    try {
      const lowerArchMovementModule = this.GetModuleLowerArchMovement()
      if (!lowerArchMovementModule) {
        return
      }
      return lowerArchMovementModule.GetRotateAngle()
    } catch (e) {
      console.log("GetRotateAngle:", e)
      return null
    }
  }

  // 设置当前GM全部移动状态
  SetCallBackForArchMovedOfGM(funName: string) {
    if (!wasmModule.isFinishedOpencase) {
      return undefined
    }
    try {
      wasmModule.moduleManager.SetCallBackForArchMovedOfGM(funName)
    } catch (e) {
      console.log("设置 ToggleLowerArchMove All:", e)
    }
  }

  // 设置单个GM移动回调函数
  SetControllArchMove(isPlus: boolean, direction: number, step: number) {
    try {
      const lowerArchMovementModule = this.GetModuleLowerArchMovement()

      if (!lowerArchMovementModule) {
        return
      }
      lowerArchMovementModule.ControllArchMove(isPlus, direction, step)
    } catch (e) {
      console.log("SetControllArchMove:", e)
    }
  }

  // 重置GM移动状态
  OnClearAll() {
    try {
      const lowerArchMovementModule = this.GetModuleLowerArchMovement()
      if (!lowerArchMovementModule) {
        return
      }
      lowerArchMovementModule.OnClearAll()
    } catch (e) {
      console.log("OnClearAll:", e)
    }
  }
}

export const globalMovement = new GlobalMovement()
